import { cn } from "./internal/cn";
import { ClassValue } from "clsx";

type Props = {
  size?: number;
  className?: ClassValue;
  pathClass?: ClassValue;
};

export const ChevronRightIcon = (props: Props) => {
  const { size = 16, className, pathClass } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={cn(className && className)}
    >
      <path
        d="M6 3.5L10.5 8L6 12.5"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={cn(pathClass && pathClass)}
      />
    </svg>
  );
};
